module.exports = __webpack_public_path__ + "static/media/branch.29ef9750.png";